<template>
    <div :class="relationsNetworkMenuClassNames">
        <div class="relations-network-menu__item blue-red-hover-text" @click="resetDefault">
            <i class="uk-icon-refresh"></i>
            <span>Сбросить</span>
        </div>

        <div class="relations-network-menu__item blue-red-hover-text" @click="showRelationsAsList">
            <i class="uk-icon-file-text-o"></i>
            <span>Список</span>
        </div>

        <div class="relations-network-menu__item blue-red-hover-text" @click="toggleFullScreen">
            <template v-if="fullscreen">
                <i class="uk-icon-compress"></i>
                <span>Свернуть</span>
            </template>
            <template v-else>
                <i class="uk-icon-arrows-alt"></i>
                <span>На весь экран</span>
            </template>
        </div>

        <div class="relations-network-menu__item blue-red-hover-text" @click="printImage">
            <i class="uk-icon-print"></i>
            <span>Распечатать</span>
        </div>

        <div class="relations-network-menu__item blue-red-hover-text" @click="downloadImage">
            <i class="uk-icon-save"></i>
            <span>Сохранить</span>
        </div>

        <div class="relations-network-menu__item blue-red-hover-text" @click="toggleLegend">
            <span v-if="!showLegend">Показать легенду</span>
            <span v-else style="width: 153px; display: inline-block; text-align: right;">Скрыть легенду</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        downloadImage: Function,
        printImage: Function,
        toggleFullScreen: Function,
        showRelationsAsList: Function,
        resetDefault: Function,
        fullscreen: Boolean,
        showLegend: Boolean,
        toggleLegend: Function
    },
    computed: {
        relationsNetworkMenuClassNames() {
            return {
                'relations-network-menu': true,
                'relations-network-menu_fullscreen': this.$props.fullscreen
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@use 'styles/global-variables.sass'

.blue-red-hover-text
    color: #3b5998
    cursor: pointer
    font-weight: 600
    border: 0
    text-decoration: none
    &:hover
        color: rgba(255,50,50,1.0) !important

.relations-network-menu
    background-color: #fff
    display: flex
    width: 100%
    justify-content: space-around
    z-index: 1
    position: absolute
    &__item
        display: inline-block
        user-select: none
        i
            margin-right: 5px
    &_fullscreen
        flex-direction: column
        width: 200px
        right: 0
        text-align: right
        .relations-network-menu__item
            margin-right: 20px
            margin-top: 10px
</style>